import _ from 'lodash-es';

const selectedNode = (/** @type {any} */ id, /** @type {any} */ tree) => {
	/** @type {any} */
	let returnValue = null;
	for (const item of Object.values(tree)) {
		if (item.id === id) {
			returnValue = item;
		}
		else if (!returnValue && item.children.length > 0) {
			returnValue = selectedNode(id, item.children);
		}
	}
	return returnValue;
};

export default class KformTreeController {
	/* @ngInject */
	/**
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor($scope, $timeout) {
		this.$scope = $scope;
		this.$timeout = $timeout;

		/** @type {?import('../kform.controller').default} */
		this.kform = null;

		/** @type {import('~/scripts/services/model/form').default[]} */
		this.forms = [];

		/** @type {any[]} */
		this.formTreeData = [];

		/** @type {any[]} */
		this.formTreeExpandedNodes = [];

		/** @type {any} */
		this.options = {
			selectedNode: null,
		};
		this.selectedForm = undefined;
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (
			changes.selectedForm && changes.selectedForm.currentValue
			&& changes.selectedForm.previousValue !== changes.selectedForm.currentValue
		) {
			this.options.selectedNode = selectedNode(this.selectedForm, this.formTreeData);
		}
	}

	$onInit() {
		const buildHierarchy = (/** @type {any} */ forms) => {
			/** @type {any[]} */
			const tree = [];

			/** @type {any} */
			const children = {};

			let index;

			// find the top level nodes and hash the children based on parent
			if (forms) {
				for (const form of Object.values(forms)) {
					const branch = {
						label:    form.isa.objname + (form.name ? ` : ${form.name}` : ''),
						lastForm: form.lastForm,
						id:       form.kid,
						children: [],
						valid:    form.formio && form.formio.kformForm ? form.formio.kformForm.$valid : true,
					};
					if (form.parent) {
						if (!(form.parent.form in children)) {
							children[form.parent.form] = [];
						}
						children[form.parent.form].push(branch);
					}
					else {
						tree.push(branch);
					}
					this.formTreeExpandedNodes.push(branch);
				}
			}

			// function to recursively build the tree
			const findChildren = (/** @type {any} */ parent) => {
				if (parent.id in children) {
					parent.children = children[parent.id];
					let index2 = 0;
					for (; index2 < parent.children.length; ++index2) {
						findChildren(parent.children[index2]);
					}
				}
			};

			const { length } = tree;
			// enumerate through to handle the case where there are multiple roots
			for (index = 0; index < length; ++index) {
				findChildren(tree[index]);
			}

			_.merge(this.formTreeData, tree);
			this.options.selectedNode = selectedNode(this.selectedForm, tree);
			// this.formTreeData = tree;
		};

		this.$scope.$watch(() => {
			/** @type {any[]} */
			const sform = [];
			if (this.forms && typeof this.forms === 'object') {
				for (const form of Object.values(this.forms)) {
					sform.push(JSON.stringify({
						name:  form.name,
						isa:   form.isa.objid,
						valid: form.formio && form.formio.kformForm ? form.formio.kformForm.$valid : true,
					}));
				}
			}
			return sform;
		}, () => {
			this.$timeout(() => {
				buildHierarchy(this.forms);
			});
		}, true);
	}

	/**
	 * @param {any} node
	 */
	formTreeHandler(node) {
		this.selectedForm = node.id;
		if (this.kform && 'currentClassForm' in this.kform) {
			this.kform.currentClassForm = this.selectedForm;
		}
	}
}
